import { render, staticRenderFns } from "./ReserveReceptionBeta.vue?vue&type=template&id=8ddb04b0&scoped=true"
import script from "./ReserveReceptionBeta.vue?vue&type=script&lang=js"
export * from "./ReserveReceptionBeta.vue?vue&type=script&lang=js"
import style0 from "./ReserveReceptionBeta.vue?vue&type=style&index=0&id=8ddb04b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddb04b0",
  null
  
)

export default component.exports